<div class="registrationStage">
    <gol-linkaccount [newUser]="true" (cifNo)="continue($event)" (back)="back($event)" (cancel)="cancel($event)"
        (skip)="skip($event)"></gol-linkaccount>
</div>